/**
 * ChatFooter - Footer area with help links
 * 
 * Provides quick access to:
 * - Contact support
 * - Documentation
 * - Community
 */

import { ExternalLink, Span, Text } from "@netapp/bxp-design-system-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { allMenus as i18nNamespace } from "../../../../../../i18n/namespace";
import { ReactComponent as Contact } from "../assets/ic_contact.svg";
import { ReactComponent as Documentation } from "../assets/ic_documentation.svg";
import { ReactComponent as Members } from "../assets/ic_members.svg";
import chatStyles from "./ChatContainer.module.scss";

const FooterLinkItem = ({ icon, href, children }) => {
    return (
        <div className={chatStyles['footer-link-item']}>
            {icon}
            <ExternalLink variant="text" color="secondary" href={href}>
                {children}
            </ExternalLink>
        </div>
    );
};

FooterLinkItem.displayName = 'FooterLinkItem';

const ChatFooter = React.memo(() => {
    const { t } = useTranslation(i18nNamespace);

    return (
        <div className={chatStyles['menu-footer']}>
            <Text>
                {t("ai_get_more_help", "Get more help")}
            </Text>
            <div className={chatStyles['footer-links']}>
                <FooterLinkItem
                    icon={<Contact />}
                    href="http://support.netapp.com"
                >
                    {t("ai_contact_support", "Contact support")}
                </FooterLinkItem>
                <FooterLinkItem
                    icon={<Documentation />}
                    href="http://docs.netapp.com"
                >
                    {t("ai_view_docs", "View documentation")}
                </FooterLinkItem>
                <FooterLinkItem
                    icon={<Members />}
                    href="http://community.netapp.com"
                >
                    {t("ai_community", "Community")}
                </FooterLinkItem>
            </div>
        </div>
    );
});

ChatFooter.displayName = 'ChatFooter';

export default ChatFooter;
